package com.vidaensupalabra.vsp

import org.jetbrains.compose.web.renderComposable

fun main() {
    // Apuntamos al ID del div que pusimos en el HTML
    renderComposable(rootElementId = "root") {
        App()
    }
}